import { ApiAbout, ApiUpdatesApply } from "./Devices";

export const CheckForUpdates = async (updateCallbacks: () => void, completedCallbacks: () => void, failedCallbacks: () => void) => {
    const deviceLinkAbout = await ApiAbout();

    if (deviceLinkAbout.isUpdatePending) {
        updateCallbacks();
        try {
            const isApplied = await ApiUpdatesApply();
            completedCallbacks();
            return isApplied;
        } catch {
            failedCallbacks();
            return false;
        }
    }
return false;
}
